<template>
  <div
    v-if="tags && tags.length"
    class="product__badges relative"
  >
    <div class="badges__card-badge group flex flex-col gap-1">
      <ProductCardBadges
        :tags="tags"
      />
      <ProductCardDisclaimer
        v-if="isBWareProduct"
        class="color-EXPONDO-black text-xs"
      />
    </div>
  </div>
</template>

<script lang="ts">

import { PRODUCT_TAG } from '~~/types/product/attribute/ProductTag';

export default defineComponent({
  name: 'ProductCardBadgeWrapper',

  props: {
    attributesLocalized: {
      type: Object,
      required: true,
    },
  },
  setup(props) {

    const tags = computed(() => {

      return props.attributesLocalized?.tags ?? [];
    
    });

    const isBWareProduct = tags.value.includes(PRODUCT_TAG.Bware);

    return {
      tags,
      isBWareProduct,
    };
  
  },
});

</script>
